export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-swap-box-line', count: 1280 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line', count: 960 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 840 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 720 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 560 },
  { slug: 'jilu', name: '纪录片', icon: 'ri-film-line', count: 430 },
  { slug: 'donghua', name: '动画片', icon: 'ri-emotion-line', count: 680 },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line', count: 320 },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line', count: 500 },
  { slug: 'fanzui', name: '犯罪片', icon: 'ri-spy-line', count: 450 },
];

export const movies = [
  {
    id: 1,
    title: '星际穿越',
    titleEn: 'Interstellar',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2014,
    rating: 9.4,
    quality: '蓝光4K',
    duration: '169分钟',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
    description: '在不远的未来，地球气候恶化，水资源枯竭，粮食短缺。前NASA宇航员库珀被选中参与一项穿越虫洞、为人类寻找新家园的绝密任务。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Interstellar%20sci-fi%20movie%20poster%20style%2C%20vast%20cosmic%20space%20with%20wormhole%20and%20black%20hole%2C%20a%20lone%20spacecraft%20traveling%20through%20stars%2C%20dramatic%20lighting%2C%20deep%20space%20colors%20with%20warm%20golden%20accents%2C%20cinematic%20composition%2C%20epic%20scale%2C%20dark%20background%20with%20star%20clusters%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20atmospheric%20and%20emotional%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-interstellar-01&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Interstellar%20sci-fi%20movie%20poster%20style%2C%20vast%20cosmic%20space%20with%20wormhole%20and%20black%20hole%2C%20a%20lone%20spacecraft%20traveling%20through%20stars%2C%20dramatic%20lighting%2C%20deep%20space%20colors%20with%20warm%20golden%20accents%2C%20cinematic%20composition%2C%20epic%20scale%2C%20dark%20background%20with%20star%20clusters%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20atmospheric%20and%20emotional%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-interstellar-01&orientation=portrait',
    featured: true,
    hot: true,
    new: false,
  },
  {
    id: 2,
    title: '流浪地球2',
    titleEn: 'The Wandering Earth II',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2023,
    rating: 8.3,
    quality: '蓝光4K',
    duration: '173分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启了长达2500年的流浪之旅。本片作为前传，讲述了这场宏大冒险的起源与人类面对的终极考验。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%20II%20Chinese%20sci-fi%20movie%20poster%2C%20futuristic%20Earth%20with%20massive%20planetary%20engines%20glowing%20blue%20against%20dark%20space%2C%20dramatic%20cosmic%20scene%20with%20ice%20and%20fire%20contrast%2C%20epic%20scale%2C%20Chinese%20science%20fiction%20aesthetic%2C%20celestial%20background%2C%20intense%20warm%20and%20cool%20color%20fusion%2C%20cinematic%20lighting%2C%20highly%20detailed%2C%208K%20quality%2C%20atmospheric%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-wandering-earth-02&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%20II%20Chinese%20sci-fi%20movie%20poster%2C%20futuristic%20Earth%20with%20massive%20planetary%20engines%20glowing%20blue%20against%20dark%20space%2C%20dramatic%20cosmic%20scene%20with%20ice%20and%20fire%20contrast%2C%20epic%20scale%2C%20Chinese%20science%20fiction%20aesthetic%2C%20celestial%20background%2C%20intense%20warm%20and%20cool%20color%20fusion%2C%20cinematic%20lighting%2C%20highly%20detailed%2C%208K%20quality%2C%20atmospheric%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-wandering-earth-02&orientation=portrait',
    featured: true,
    hot: true,
    new: true,
  },
  {
    id: 3,
    title: '速度与激情10',
    titleEn: 'Fast X',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2023,
    rating: 7.2,
    quality: '蓝光4K',
    duration: '141分钟',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '杰森·莫玛', '布丽·拉尔森'],
    description: '多米尼克和他的家人面临着有史以来最致命的对手——一个从过去的阴影中崛起的可怕威胁，为了守护挚爱之人，他们将不惜一切代价。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Fast%20and%20Furious%20X%20action%20movie%20poster%20style%2C%20high-speed%20sports%20car%20racing%20through%20city%20streets%20at%20night%2C%20explosive%20orange%20and%20red%20flames%2C%20dramatic%20urban%20background%2C%20intense%20motion%20blur%2C%20Hollywood%20blockbuster%20aesthetic%2C%20dark%20sky%20with%20neon%20reflections%2C%20adrenaline-pumping%20action%20scene%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-fastx-03&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Fast%20and%20Furious%20X%20action%20movie%20poster%20style%2C%20high-speed%20sports%20car%20racing%20through%20city%20streets%20at%20night%2C%20explosive%20orange%20and%20red%20flames%2C%20dramatic%20urban%20background%2C%20intense%20motion%20blur%2C%20Hollywood%20blockbuster%20aesthetic%2C%20dark%20sky%20with%20neon%20reflections%2C%20adrenaline-pumping%20action%20scene%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-fastx-03&orientation=portrait',
    featured: true,
    hot: false,
    new: false,
  },
  {
    id: 4,
    title: '你好，李焕英',
    titleEn: 'Hi, Mom',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2021,
    rating: 8.1,
    quality: '1080P',
    duration: '128分钟',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾'],
    description: '2001年的某一天，刚刚考上大学的贾晓玲遭遇了人生中的一次重大变故。情绪崩溃中，她竟意外穿越到了1981年，与自己年轻的母亲李焕英相遇。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20film%20poster%20style%2C%20warm%20nostalgic%201980s%20Chinese%20factory%20setting%2C%20mother%20and%20daughter%20embracing%20with%20warm%20smiles%2C%20soft%20golden%20sunlight%2C%20vintage%20Chinese%20aesthetic%2C%20emotional%20heartwarming%20scene%2C%20pastel%20yellow%20and%20warm%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-hi-mom-04&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20film%20poster%20style%2C%20warm%20nostalgic%201980s%20Chinese%20factory%20setting%2C%20mother%20and%20daughter%20embracing%20with%20warm%20smiles%2C%20soft%20golden%20sunlight%2C%20vintage%20Chinese%20aesthetic%2C%20emotional%20heartwarming%20scene%2C%20pastel%20yellow%20and%20warm%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-hi-mom-04&orientation=portrait',
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 5,
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 1997,
    rating: 9.4,
    quality: '蓝光4K',
    duration: '194分钟',
    director: '詹姆斯·卡梅隆',
    cast: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    description: '1912年泰坦尼克号沉没事件为背景，讲述了穷画家杰克和贵族女孩露丝抛弃世俗偏见坠入爱河，最终在灾难面前生离死别的感人爱情故事。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Titanic%20romance%20movie%20poster%20style%2C%20iconic%20scene%20of%20couple%20standing%20at%20ship%20bow%20during%20golden%20sunset%20over%20vast%20ocean%2C%20warm%20romantic%20colors%2C%20vintage%201910s%20aesthetic%2C%20dramatic%20clouds%20and%20soft%20lighting%2C%20emotional%20epic%20romance%20atmosphere%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-titanic-05&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Titanic%20romance%20movie%20poster%20style%2C%20iconic%20scene%20of%20couple%20standing%20at%20ship%20bow%20during%20golden%20sunset%20over%20vast%20ocean%2C%20warm%20romantic%20colors%2C%20vintage%201910s%20aesthetic%2C%20dramatic%20clouds%20and%20soft%20lighting%2C%20emotional%20epic%20romance%20atmosphere%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-titanic-05&orientation=portrait',
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 6,
    title: '长津湖',
    titleEn: 'The Battle at Lake Changjin',
    category: '战争片',
    categorySlug: 'zhanzheng',
    year: 2021,
    rating: 7.4,
    quality: '蓝光4K',
    duration: '176分钟',
    director: '陈凯歌 / 徐克 / 林超贤',
    cast: ['吴京', '易烊千玺', '段奕宏'],
    description: '1950年，中国志愿军部队与美军在朝鲜长津湖地区交战。在零下40度的极寒严酷环境下，志愿军战士们凭着钢铁意志和英勇无畏的战斗精神，扭转了战场态势。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=The%20Battle%20at%20Lake%20Changjin%20Chinese%20war%20film%20poster%2C%20soldiers%20in%20winter%20warfare%20gear%20standing%20strong%20in%20snow-covered%20mountainous%20battlefield%2C%20dramatic%20cold%20blue%20and%20white%20atmosphere%2C%20intense%20war%20scene%20with%20determination%2C%20epic%20scale%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-changjin-06&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=The%20Battle%20at%20Lake%20Changjin%20Chinese%20war%20film%20poster%2C%20soldiers%20in%20winter%20warfare%20gear%20standing%20strong%20in%20snow-covered%20mountainous%20battlefield%2C%20dramatic%20cold%20blue%20and%20white%20atmosphere%2C%20intense%20war%20scene%20with%20determination%2C%20epic%20scale%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-changjin-06&orientation=portrait',
    featured: false,
    hot: true,
    new: false,
  },
  {
    id: 7,
    title: '寻梦环游记',
    titleEn: 'Coco',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2017,
    rating: 9.1,
    quality: '蓝光4K',
    duration: '105分钟',
    director: '李·昂克里奇',
    cast: ['安东尼·冈萨雷斯', '盖尔·加西亚·贝纳尔'],
    description: '热爱音乐的米格尔不幸地出生在一个视音乐为洪水猛兽的大家庭。在亡灵节那天，他因为一把吉他意外进入了亡灵世界，并与他已故的曾曾祖父相遇。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Coco%20Pixar%20animated%20film%20poster%20style%2C%20young%20boy%20with%20guitar%20in%20colorful%20Mexican%20Day%20of%20the%20Dead%20world%20with%20glowing%20marigold%20petals%2C%20vibrant%20orange%20and%20purple%20tones%2C%20magical%20fantasy%20atmosphere%2C%20beautiful%20warm%20lighting%2C%20heartwarming%20family%20theme%2C%20cinematic%20composition%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-coco-07&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Coco%20Pixar%20animated%20film%20poster%20style%2C%20young%20boy%20with%20guitar%20in%20colorful%20Mexican%20Day%20of%20the%20Dead%20world%20with%20glowing%20marigold%20petals%2C%20vibrant%20orange%20and%20purple%20tones%2C%20magical%20fantasy%20atmosphere%2C%20beautiful%20warm%20lighting%2C%20heartwarming%20family%20theme%2C%20cinematic%20composition%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-coco-07&orientation=portrait',
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 8,
    title: '招魂3',
    titleEn: 'The Conjuring: The Devil Made Me Do It',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2021,
    rating: 6.5,
    quality: '1080P',
    duration: '112分钟',
    director: '迈克尔·查韦斯',
    cast: ['帕特里克·威尔森', '维拉·法米加'],
    description: '沃伦夫妇调查一起令人震惊的谋杀案，这可能是他们遇到的最黑暗的案件。一名嫌疑人声称自己被恶魔附身，而这背后隐藏着更加可怕的真相。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=The%20Conjuring%20horror%20film%20poster%20style%2C%20dark%20haunted%20house%20with%20eerie%20supernatural%20atmosphere%2C%20dim%20candlelight%20casting%20long%20shadows%2C%20gothic%20aesthetic%2C%20cold%20blue%20and%20deep%20black%20tones%2C%20spooky%20suspenseful%20mood%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-conjuring-08&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=The%20Conjuring%20horror%20film%20poster%20style%2C%20dark%20haunted%20house%20with%20eerie%20supernatural%20atmosphere%2C%20dim%20candlelight%20casting%20long%20shadows%2C%20gothic%20aesthetic%2C%20cold%20blue%20and%20deep%20black%20tones%2C%20spooky%20suspenseful%20mood%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-conjuring-08&orientation=portrait',
    featured: false,
    hot: false,
    new: true,
  },
  {
    id: 9,
    title: '满江红',
    titleEn: 'Full River Red',
    category: '悬疑片',
    categorySlug: 'xuanyi',
    year: 2023,
    rating: 7.7,
    quality: '蓝光4K',
    duration: '159分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案牵扯出惊天秘密，小兵张大与亲兵营副统领孙均被裹挟进这场巨大的阴谋之中。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20Chinese%20historical%20suspense%20film%20poster%2C%20ancient%20Chinese%20courtyard%20with%20dramatic%20red%20lanterns%20and%20shadows%2C%20Song%20Dynasty%20aesthetic%2C%20mysterious%20atmosphere%20with%20tension%2C%20deep%20red%20and%20dark%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-fullriver-09&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20Chinese%20historical%20suspense%20film%20poster%2C%20ancient%20Chinese%20courtyard%20with%20dramatic%20red%20lanterns%20and%20shadows%2C%20Song%20Dynasty%20aesthetic%2C%20mysterious%20atmosphere%20with%20tension%2C%20deep%20red%20and%20dark%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-fullriver-09&orientation=portrait',
    featured: true,
    hot: true,
    new: true,
  },
  {
    id: 10,
    title: '无间道',
    titleEn: 'Infernal Affairs',
    category: '犯罪片',
    categorySlug: 'fanzui',
    year: 2002,
    rating: 9.3,
    quality: '蓝光4K',
    duration: '101分钟',
    director: '刘伟强 / 麦兆辉',
    cast: ['刘德华', '梁朝伟', '黄秋生'],
    description: '两个身份混乱的男人分别为警方和黑社会的卧底，经过一场激烈的角斗，他们决心要寻回自己。香港警匪片的巅峰之作，被誉为港片最后的辉煌。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Infernal%20Affairs%20Hong%20Kong%20crime%20thriller%20poster%20style%2C%20two%20men%20in%20suits%20standing%20on%20rooftop%20with%20city%20skyline%2C%20intense%20eye%20contact%20and%20tension%2C%20dark%20blue%20and%20gray%20urban%20atmosphere%2C%20neo-noir%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-infernal-10&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Infernal%20Affairs%20Hong%20Kong%20crime%20thriller%20poster%20style%2C%20two%20men%20in%20suits%20standing%20on%20rooftop%20with%20city%20skyline%2C%20intense%20eye%20contact%20and%20tension%2C%20dark%20blue%20and%20gray%20urban%20atmosphere%2C%20neo-noir%20aesthetic%2C%20dramatic%20cinematic%20lighting%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-infernal-10&orientation=portrait',
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 11,
    title: '阿凡达：水之道',
    titleEn: 'Avatar: The Way of Water',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2022,
    rating: 7.9,
    quality: '蓝光4K',
    duration: '192分钟',
    director: '詹姆斯·卡梅隆',
    cast: ['萨姆·沃辛顿', '佐伊·索尔达娜'],
    description: '杰克和奈蒂莉组建了家庭，他们的孩子也逐渐成长。然而危机再度降临，他们被迫离开家园，来到潘多拉星球的海洋世界寻求庇护。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Avatar%20the%20Way%20of%20Water%20sci-fi%20film%20poster%2C%20blue%20Na-vi%20characters%20swimming%20in%20bioluminescent%20Pandora%20ocean%2C%20underwater%20fantasy%20world%20with%20glowing%20creatures%20and%20coral%2C%20ethereal%20blue%20and%20turquoise%20tones%2C%20epic%20cinematic%20scale%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-avatar-11&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Avatar%20the%20Way%20of%20Water%20sci-fi%20film%20poster%2C%20blue%20Na-vi%20characters%20swimming%20in%20bioluminescent%20Pandora%20ocean%2C%20underwater%20fantasy%20world%20with%20glowing%20creatures%20and%20coral%2C%20ethereal%20blue%20and%20turquoise%20tones%2C%20epic%20cinematic%20scale%2C%20highly%20detailed%20digital%20art%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-avatar-11&orientation=portrait',
    featured: false,
    hot: false,
    new: false,
  },
  {
    id: 12,
    title: '独行月球',
    titleEn: 'Moon Man',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2022,
    rating: 7.2,
    quality: '蓝光4K',
    duration: '122分钟',
    director: '张吃鱼',
    cast: ['沈腾', '马丽'],
    description: '人类为抵御小行星撞击，部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人落在了月球。',
    imageLandscape: 'https://readdy.ai/api/search-image?query=Moon%20Man%20Chinese%20sci-fi%20comedy%20film%20poster%2C%20a%20lone%20astronaut%20standing%20on%20lunar%20surface%20with%20Earth%20in%20background%2C%20humorous%20and%20isolated%20atmosphere%2C%20dark%20space%20with%20bright%20Earth%20glow%2C%20silver%20and%20blue%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=800&height=450&seq=movie-moonman-12&orientation=landscape',
    imagePortrait: 'https://readdy.ai/api/search-image?query=Moon%20Man%20Chinese%20sci-fi%20comedy%20film%20poster%2C%20a%20lone%20astronaut%20standing%20on%20lunar%20surface%20with%20Earth%20in%20background%2C%20humorous%20and%20isolated%20atmosphere%2C%20dark%20space%20with%20bright%20Earth%20glow%2C%20silver%20and%20blue%20tones%2C%20cinematic%20composition%2C%20highly%20detailed%2C%208K%20quality%2C%20no%20text%20or%20logos&width=400&height=600&seq=movie-moonman-12&orientation=portrait',
    featured: false,
    hot: true,
    new: false,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024年最值得期待的十部好莱坞大片',
    slug: '2024-hollywood-most-anticipated',
    excerpt: '从超级英雄续作到科幻巨制，2024年好莱坞将带来一系列令人震撼的大银幕体验。本文将为你盘点明年不容错过的十部重磅大片。',
    content: '<p>2024年对于电影爱好者来说注定是不平凡的一年。随着疫情的阴霾逐渐散去，好莱坞各大制片厂纷纷拿出了压箱底的超级制作，准备在新的一年给全球观众带来视听盛宴。</p><h2>1. 《沙丘2》—— 史诗科幻续作</h2><p>丹尼斯·维伦纽瓦执导的《沙丘》续集无疑是2024年最受瞩目的电影之一。保罗·厄崔迪斯的传奇故事将继续展开，他将与弗雷曼人并肩作战，向摧毁他家族的势力复仇。提莫西·查拉梅、赞达亚等原班人马悉数回归，更有克里斯托弗·沃肯等实力派演员加盟。</p><h2>2. 《死侍3》—— 嘴炮英雄回归</h2><p>瑞安·雷诺兹再度披上红色战衣，这一次他还带来了休·杰克曼饰演的金刚狼！两位角色的首次同框让无数漫威粉丝翘首以盼。据悉本片将正式将X战警世界纳入漫威电影宇宙。</p><h2>3. 《哥斯拉大战金刚2》</h2><p>怪兽宇宙继续扩张，两大顶级泰坦巨兽再次交锋。在这一部中，哥斯拉和金刚将面对一个全新的、更加可怕的威胁——来自地心世界的远古巨兽。</p><p>除此之外，《阿凡达3》、《碟中谍8》、《头脑特工队2》等作品同样令人期待。2024年的大银幕，精彩不容错过！</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Hollywood%20movie%20anticipation%20concept%20art%2C%20film%20reel%20and%20clapperboard%20against%20dramatic%20cinema%20screen%20with%20golden%20spotlights%2C%20red%20velvet%20theater%20curtain%2C%20glamorous%20award-show%20aesthetic%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20cinematic%20atmosphere%2C%20highly%20detailed%2C%208K%20quality&width=600&height=340&seq=article-hollywood-2024&orientation=landscape',
    category: '电影资讯',
    date: '2024-01-15',
    author: '星辰影评',
    views: 15820,
  },
  {
    id: 2,
    title: '中国科幻电影的崛起之路',
    slug: 'chinese-scifi-film-rise',
    excerpt: '从《流浪地球》到《三体》，中国科幻电影正在经历前所未有的黄金时代。深入分析中国科幻电影的成长历程与未来前景。',
    content: '<p>2019年，《流浪地球》以46.86亿的票房成绩震惊了整个电影行业。这不仅是一部电影的成功，更标志着中国科幻电影元年的开启。</p><h2>从零到一的突破</h2><p>在《流浪地球》之前，中国科幻电影几乎是一片空白。虽然偶有尝试，但无论是特效水平还是叙事能力，都与好莱坞存在巨大差距。郭帆导演和他的团队用了四年时间，克服了无数技术难题，最终打造出这部具有里程碑意义的作品。</p><h2>技术积累与工业体系</h2><p>《流浪地球2》的推出进一步证明了中国科幻电影的进步。更加成熟的视觉特效、更加宏大的世界观构建、更加深入的人文思考，都显示着中国科幻电影正在迅速成长。</p><p>随着越来越多的资本和人才涌入这一领域，中国科幻电影的未来值得期待。从《三体》到《封神》系列，中国正在用自己独特的文化视角，讲述属于自己的科幻故事。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20science%20fiction%20concept%20art%2C%20futuristic%20cityscape%20with%20traditional%20Chinese%20architectural%20elements%2C%20floating%20lanterns%20and%20holographic%20projections%2C%20cyberpunk%20meets%20ancient%20China%20aesthetic%2C%20deep%20blue%20and%20warm%20gold%20tones%2C%20epic%20scale%2C%20highly%20detailed%20digital%20art%2C%208K%20quality&width=600&height=340&seq=article-chinese-scifi&orientation=landscape',
    category: '深度影评',
    date: '2024-02-20',
    author: '电影观察者',
    views: 12560,
  },
  {
    id: 3,
    title: '如何选择适合自己的观影设备？家庭影院搭建指南',
    slug: 'home-theater-guide',
    excerpt: '从投影仪到音响系统，从屏幕尺寸到房间布局，手把手教你打造完美的家庭影院，享受沉浸式观影体验。',
    content: '<p>随着4K蓝光技术的普及和流媒体平台的发展，越来越多的人选择在家中享受高品质的电影体验。但如何搭建一套适合自己的家庭影院系统呢？</p><h2>显示设备的选择</h2><p>百寸以上的画面是影院感的基石。目前主流选择有两种：大尺寸电视和投影仪。85寸以上的Mini-LED电视画质出色，但价格不菲；而4K投影仪配合抗光幕布，可以在较低预算下获得更大的画面。</p><h2>音响系统的配置</h2><p>声音是观影体验中不可忽视的一环。入门级5.1声道系统就能带来环绕声的沉浸感，而发烧友可以考虑7.1.4杜比全景声系统。回音壁也是一个不错的折中方案。</p><h2>环境光的控制</h2><p>一间好的影音室必须能够完全遮光。遮光窗帘是必不可少的配置，同时墙壁颜色建议选择深色调，以减少反光对画面的干扰。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20home%20theater%20room%20interior%20design%2C%20cozy%20basement%20cinema%20with%20comfortable%20recliner%20seating%2C%20large%20projector%20screen%2C%20warm%20ambient%20LED%20lighting%2C%20acoustic%20wall%20panels%2C%20luxury%20residential%20entertainment%20space%2C%20dark%20walls%20with%20soft%20indirect%20lighting%2C%20premium%20home%20cinema%20aesthetic%2C%20highly%20detailed%2C%208K%20quality&width=600&height=340&seq=article-home-theater&orientation=landscape',
    category: '观影指南',
    date: '2024-03-10',
    author: '影音达人',
    views: 8930,
  },
  {
    id: 4,
    title: '诺兰电影中的时间叙事艺术',
    slug: 'nolan-time-narrative-art',
    excerpt: '从《记忆碎片》到《信条》，克里斯托弗·诺兰以其独特的时间叙事手法，不断挑战观众对电影叙事的认知边界。',
    content: '<p>在当代电影导演中，没有人比克里斯托弗·诺兰更痴迷于时间这一主题。从早期的《记忆碎片》到近期的《信条》，时间始终是他作品中最核心的叙事元素。</p><h2>破碎的时间线</h2><p>《记忆碎片》采用倒叙和正叙交替的双线叙事结构，让观众与主角一样陷入记忆的迷宫。这种叙事方式不仅是一种技巧实验，更是对角色处境的一种映射。</p><h2>时间的相对性</h2><p>《星际穿越》中，诺兰将爱因斯坦的相对论融入叙事。米勒星球上的一个小时等于地球上的七年——这种时间膨胀不仅是科学设定，更是推动情感冲突的核心动力。</p><p>诺兰通过对时间的解构和重组，创造出独一无二的电影体验。他的每一部作品都在提醒我们：在电影的世界里，时间是可以被雕刻的艺术。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20clock%20and%20film%20concept%20art%2C%20surreal%20time%20visualization%20with%20melting%20clocks%20and%20film%20strips%20intertwining%2C%20Christopher%20Nolan%20aesthetic%2C%20mind-bending%20geometric%20patterns%2C%20deep%20blue%20and%20amber%20tones%2C%20cerebral%20and%20intellectual%20atmosphere%2C%20highly%20detailed%20digital%20art%2C%208K%20quality&width=600&height=340&seq=article-nolan-time&orientation=landscape',
    category: '深度影评',
    date: '2024-04-05',
    author: '星辰影评',
    views: 11250,
  },
  {
    id: 5,
    title: '动画电影的成人世界：那些写给大人的童话',
    slug: 'animation-for-adults',
    excerpt: '动画从来不只是儿童的专利。皮克斯、宫崎骏等大师的动画作品，往往蕴含着令成年人潸然泪下的人生哲理。',
    content: '<p>很多人认为动画片只是给孩子看的，但真正优秀的动画电影往往能够跨越年龄的界限，触及每个人内心最深处的柔软。</p><h2>皮克斯的情感哲学</h2><p>从《飞屋环游记》开篇那被誉为"史上最动人十分钟"，到《寻梦环游记》对家庭与记忆的深情诠释，皮克斯总能用最精良的技术讲述最质朴的情感故事。《头脑特工队》更是将人类情绪拟人化，让观众重新审视自己的内心世界。</p><h2>宫崎骏的奇幻寓言</h2><p>宫崎骏的动画作品表面上是奇幻冒险，内核却充满了对战争、环保、成长的深刻思考。《千与千寻》中的无脸男象征着现代人的孤独，《幽灵公主》探讨了人与自然的关系。</p><p>这些动画电影提醒我们：在成年人的世界里，保持一颗童心同样重要。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20film%20concept%2C%20Studio%20Ghibli%20meets%20Pixar%20aesthetic%2C%20dreamy%20whimsical%20landscape%20with%20floating%20islands%20and%20colorful%20sky%2C%20emotional%20and%20nostalgic%20atmosphere%2C%20warm%20golden%20sunset%20lighting%2C%20hand-drawn%20animation%20style%20with%20digital%20polish%2C%20highly%20detailed%2C%208K%20quality&width=600&height=340&seq=article-adult-animation&orientation=landscape',
    category: '电影文化',
    date: '2024-05-18',
    author: '电影观察者',
    views: 9670,
  },
  {
    id: 6,
    title: '4K蓝光 vs 流媒体：哪种观影方式更适合你？',
    slug: '4k-bluray-vs-streaming',
    excerpt: '随着各大平台纷纷推出4K流媒体服务，传统的蓝光碟片还有存在的必要吗？从画质、音质到收藏价值，全方位对比分析。',
    content: '<p>Netflix、Disney+等流媒体平台已经全面支持4K HDR内容，而实体4K蓝光碟片的销量仍在稳步增长。这两个看似矛盾的消费趋势背后，反映了不同用户群体的差异化需求。</p><h2>画质对决</h2><p>虽然流媒体也标称4K分辨率，但受限于带宽，其视频码率通常在15-25Mbps。而4K蓝光碟片的码率可达60-100Mbps。在高速运动场景和暗部细节表现上，蓝光碟片的优势十分明显。</p><h2>音质差异</h2><p>对于拥有高品质音响系统的用户来说，音质的差距可能是决定性的。蓝光碟片提供的无损杜比全景声和DTS:X音轨，能够带来真正影院级的听觉体验。</p><p>最终的选择取决于你的实际需求。如果你追求极致画质音质并且喜欢收藏，4K蓝光是不可替代的选择；如果你更看重便利性和内容的丰富度，流媒体无疑更加适合。</p>',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20comparison%20scene%2C%204K%20blu-ray%20disc%20next%20to%20streaming%20device%20on%20sleek%20media%20console%2C%20split-screen%20visual%20showing%20disc%20quality%20vs%20streaming%20quality%2C%20premium%20home%20cinema%20setup%2C%20clean%20minimalist%20tech%20aesthetic%2C%20dark%20room%20with%20accent%20lighting%2C%20highly%20detailed%20product%20photography%2C%208K%20quality&width=600&height=340&seq=article-4k-comparison&orientation=landscape',
    category: '观影指南',
    date: '2024-06-22',
    author: '影音达人',
    views: 7580,
  },
];